export default __webpack_public_path__ + "static/media/accuracyAccountsReal_downloadMT4.c8d7d054.jpg";